import { Component, Inject, OnChanges, OnInit, PLATFORM_ID } from '@angular/core';
import { UsecasepageService } from './usecasepage.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { ContentfulEntry } from 'src/app/shared/models/common.interfaces';
import { UsecasesCaseOtherFeatureComponent } from './usecases-other-feature/usecases-other-feature.component';
import { UsecasesHeroComponent } from './usecases-hero/usecases-hero.component';
import { UsecasesCaseFeatureComponent } from './usecases-feature/usecases-feature.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonDiscoverWhyComponent } from 'src/app/shared/components/discover-why/discover-why.component';
import { CommonFaqComponent } from 'src/app/shared/components/faq/faq-on.component';
import { UsecasesCasePaymentSolutionsComponent } from './usecases-marketplace-paymentsolutions/usecases-marketplace-paymentsolutions.component';
import { UsecaseBenefitsSectionComponent } from './usecase-benefits/benefits.component';

@Component({
  selector: 'app-usecases',
  templateUrl: './usecases.component.html',
  styleUrls: ['./usecases.component.scss'],
  imports: [
    CommonModule,
    UsecasesCaseOtherFeatureComponent,
    UsecasesCasePaymentSolutionsComponent,
    UsecasesHeroComponent,
    UsecasesCaseFeatureComponent,
    CommonCompaniesPanelComponent,
    CommonSubProductsWhitePaperComponent,
    CommonDiscoverWhyComponent,
    CommonGetstartedComponent,
    CommonFaqComponent,
    UsecaseBenefitsSectionComponent
  ],
})
export class UsecasesComponent implements OnInit {
  companiesData: string[] = [];
  pageData: any;
  whitePaperData: any = {};
  getStartedData: any = {};
  discoverData: any = null;
  faqData: any = {};
  getUrl: any;
  marketPlacePaymentSolutionData: any;
  benefitsData: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  caseIdObject: any = {
    'exporters': 'Exporters',
    'telecommunications': 'Media And Telecoms',
    'health&pharmaceuticals': 'Health And Pharmaceuticals',
    'travel-and-tourism': 'Travel And Tourism',
    'charities-and-non-govermental-organisations': 'Charities And NGOs',
    'educational-institutions': 'Education Institutions',
    'energyandcommodities': 'Energy and Commodities',
    'importers': 'Importers',
    'construction': 'Construction',
    'logistics': 'Logistics And Distribution',
    'online-retail': 'Online Retail',
    'marketplaces': 'Marketplaces',
    'global-payroll': 'Global payroll',
    'creator-economy': 'Creator Economy',
    'manufacturing': 'Manufacturing',
    'trade': 'Trade',
  };
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private usecasePageService: UsecasepageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  caseStudyTemplate: string = '';
  isDifferentLayout: boolean = false;
  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this.loadTrustpilotScript();
    }
    
    try {
      const pData = await this.usecasePageService.getUsecasePageAlData();
      
      if (!pData || !Array.isArray(pData)) {
        console.error('No page data available');
        return;
      }
      
      this.route.params.subscribe(param => {
        let detail = param?.['casetype'] + '/' + param?.['caseid'];
        if(param?.['caseid'] === 'marketplaces') {
          this.isDifferentLayout = true;
        }
        this.pageData = pData.filter(el => el?.fields?.id?.toLowerCase() === detail)[0];
        
        if (!this.pageData) {
          console.error('Page data not found for:', detail);
          return;
        }
        
        this.usecasePageService.getcUsecaseData(detail);
        
        if (this.pageData?.fields?.seoMetadataReference?.fields) {
          this.meta.updateMeta(this.pageData.fields.seoMetadataReference.fields);
        }
        
        // Process pageData fields inside subscription to ensure data is available
        const data = this.pageData?.fields;
        this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
        this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
        this.metaBody.type = `${param?.['casetype'] === 'industries' ? 'Industries' : 'Use Cases'}: ${this.caseIdObject?.[param?.['caseid']] || param?.['caseid']}`;
        this.metaBody.url = this.getUrl;
        this.metaBody.image = data?.heroContentPanel?.fields?.image?.[0]?.fields?.file?.url;
        this.meta.updateOG(this.metaBody);
        if (data != null) {
          let logos = data?.customersLogos || [];
          this.companiesData = logos.map((el: ContentfulEntry) => el?.fields?.file?.url);
          this.whitePaperData = data?.featuresPanel?.[0]?.fields?.components?.[0]?.fields;
          this.discoverData = data?.caseStudyCarouselContentPanel2?.[0]?.fields;
          let datas = data?.getStartedContentPanel?.fields;
          this.faqData = data?.useCaseFaq?.fields;
          this.marketPlacePaymentSolutionData = param?.['caseid'] === 'marketplaces' ? data?.contentPanel?.[0] : null;
          this.benefitsData = data?.contentPanel?.[0]?.fields;
          if (datas) {
            this.getStartedData = {
              header: datas?.title || '',
              paragraph: datas?.content || '',
              button1: {
                url: datas?.buttons?.[0]?.fields?.redirectLink || '',
                text: datas?.buttons?.[0]?.fields?.buttonText || '',
                target: datas?.buttons?.[0]?.fields?.actionType || '',
              },
              button2: {
                url: datas?.buttons?.[1]?.fields?.redirectLink || '',
                text: datas?.buttons?.[1]?.fields?.buttonText || '',
                target: datas?.buttons?.[1]?.fields?.actionType || '',
              },
            };
          }
        }
        const caseid = param?.['caseid'];
        if (caseid) {
          this.posthogService.capturePageViewEvent(caseid);
        }
      });

      this.usecasePageService.usecaseData$.subscribe(data => {
        if (data != null) {
          this.caseStudyTemplate = data.caseStudyTemplate;
        }
      });
    } catch (error) {
      console.error('Error in ngOnInit:', error);
    }
    
    this.canonical.setCanonicalURL();

    const caseid = this.route.snapshot.params['caseid'];
    if (caseid) {
      this.posthogService.capturePageViewEvent(caseid.replace(/-/g, '_'));
    }
  }
  loadTrustpilotScript() {
    // Only load script in browser environment
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src =
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    this.document.head.appendChild(script);
    script.onload = () => {
      // Add timeout to ensure DOM is ready and iframe is created
      setTimeout(() => {
        const containerWidget: any = this.document.querySelector(
          '.trustpilot-widget iframe'
        );
        // Add null check to prevent hasAttribute error
        if (containerWidget && typeof containerWidget.hasAttribute === 'function') {
          // Additional logic can be added here if needed
        }
      }, 500);
    };
    
    script.onerror = () => {
      console.warn('Failed to load Trustpilot script');
    };
  }
}
